/**
 * Gatilho que cada seletor "qual Lexi" da régua dispara. O back resolve o fluxo escolhido
 * filtrando por `metadata.gatilho.eventType`, então o seletor só pode oferecer fluxo deste gatilho.
 */
export const GATILHOS_LEXI = {
  citacao: 'arbitral.citacao_requerido.v1',
  intimacaoSentenca: 'arbitral.intimacao_sentenca_parte.v1',
  transito: 'arbitral.transito_encaminhado_parte.v1',
} as const;
